import React from 'react';

import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ userGroupExtended, onDeleteClicked }) => (
  <tr>
    <td>{userGroupExtended.userGroupExtended[0]?.userGroupName || ''}</td>
    <td>{userGroupExtended.userGroupExtended[0]?.extendedInfo || ''}</td>
    <td>
      <button
        className={global.IconButtonMargin}
        type="button"
        onClick={() => { onDeleteClicked(userGroupExtended.userAccountGroupId) }}>
        <DeleteIcon />
      </button>
    </td>
  </tr>
);

const UserGroupGridLarge = ({ data, isLoading, onDeleteClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>User Group</th>
        <th>Extended Info</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true
        ? <tr><td colSpan="2">Loading...</td></tr>
        : Array.isArray(data) && data.length > 0
          ? data.map((userGroupExtended, i) => <GridRow key={i} userGroupExtended={userGroupExtended} onDeleteClicked={onDeleteClicked} />)
          : <tr><td colSpan="2">No User Groups</td></tr>
      }
    </tbody>
  </table>
);

export default UserGroupGridLarge;